import {Injectable} from '@angular/core';
import {combineLatest, filter, first, firstValueFrom, fromEvent, Subject, Subscription, timer} from 'rxjs';

import {MmBimService} from '../../mm-bim.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {FitSizePlanEnum, PlanService, TileViewerReadyEvent} from '@mydocma/tile-viewer';
import {PinService} from '../pin-service/pin-service';
import {switchMap} from 'rxjs/operators';

@UntilDestroy()
@Injectable()
export class PlanViewerService {

  noPlanSelectedHintBlink = false;
  private planViewerIsReadySubject = new Subject<TileViewerReadyEvent>();
  public planViewerIsReady$ = this.planViewerIsReadySubject.asObservable();
  private planReadyParams: TileViewerReadyEvent;
  private planInitLoaded = false;

  constructor(private mmBimService: MmBimService, private mmPinService: PinService) {
  }

  get pinService() {
    return this.planReadyParams?.pinService;
  }

  setNoPlanSelectedHintBlink() {
    this.noPlanSelectedHintBlink = true;
    setTimeout(() => this.noPlanSelectedHintBlink = false, 1500);
  }

  public async planReady($event: TileViewerReadyEvent): Promise<void> {
    this.planReadyParams = $event;
    const planService = ($event.mapService as PlanService);
    const planAdded = await firstValueFrom(planService.plan$.pipe(filter(Boolean), first()));
    this.planViewerIsReadySubject.next($event);
    planService.plan$.subscribe(value => {
      this.onPlanLoaded();
    });

    $event.pinService.onPinSelectionChanged.pipe(untilDestroyed(this)).subscribe((selectionChange) => {
      this.mmPinService.selectPin(selectionChange.selection[0]);
    });
  }

  private onPlanLoaded() {
    let subscription: Subscription;
    const planService = (this.planReadyParams.mapService as PlanService);
    if (!this.planInitLoaded) {
      const tileLoad$ = fromEvent(planService.planTileLayer, 'tileload');
      const load$ = fromEvent(planService.planTileLayer, 'load');
      subscription = combineLatest([tileLoad$, load$]).pipe(switchMap(p => timer(400))).subscribe(() => {
        planService.fitPlanToContainerBounds(FitSizePlanEnum.fitSize);
        subscription.unsubscribe();
        this.planInitLoaded = true;
      });
      return;
    }
    planService.fitPlanToContainerBounds(FitSizePlanEnum.fitSize);


  }


}
